import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import BomMain from '../Forms/BOM Form 3/Bom_main';
import Form_4 from '../Forms/DailyVolume_Form_4';
import StringerMain from '../Forms/Stringer Form 5/Stringer_main';
import Form_6 from '../Forms/Form_6';
import Form_7 from '../Forms/Form_7';
import Form_8 from '../Forms/Form_8';
import Form_9 from '../Forms/Form_9';
import Form_10 from '../Forms/Form_10';
import Form_11 from '../Forms/Form_11';
import Form_12 from '../Forms/Form_12';
import Form_13 from '../Forms/Form_13';
import Form_14 from '../Forms/Form_14';
import Form_15 from '../Forms/Form_15';
import Form_16 from '../Forms/Form_16';
import Form_17 from '../Forms/Form_17';
import Form_18 from '../Forms/Form_18';
// import Form_19 from '../Forms/Form_19';
// Import all the forms for Section 2

const Section2 = () => {
  const { formId } = useParams(); // Get the form ID from the route
  const navigate = useNavigate();

  const handleBackToForms = () => {
    navigate('/inspections/forms');
  };

  return (
    <div className="p-0 max-w-7xl mx-auto">

      <button
      onClick={handleBackToForms}
      className="mb-4 inline-flex items-center text-gray-700 hover:text-gray-600 font-bold text-md focus:outline-none focus:underline"
      >
        ← Back to Forms
      </button>

      <h2 className="text-2xl font-semibold mb-6">Section 2</h2>
      {/* Add conditional rendering for all Section 2 forms based on formId */}
      {formId === 'form3' && <BomMain />}
      {formId === 'form4' && <Form_4 />}
      {formId === 'form5' && <StringerMain />}
      {formId === 'form6' && <Form_6 />}
      {formId === 'form7' && <Form_7 />}
      {formId === 'form8' && <Form_8 />}
      {formId === 'form9' && <Form_9 />}
      {formId === 'form10' && <Form_10 />}
      {formId === 'form11' && <Form_11 />}
      {formId === 'form12' && <Form_12 />}
      {formId === 'form13' && <Form_13 />}
      {formId === 'form14' && <Form_14 />}
      {formId === 'form15' && <Form_15 />}
      {formId === 'form16' && <Form_16 />}
      {formId === 'form17' && <Form_17 />}
      {formId === 'form18' && <Form_18 />}
      {/* Example: {formId === 'form3' && <Form_3 />} */}
    </div>
  );
};

export default Section2;
